module.exports = require("/Users/georgina/Documents/Waza/pp/gatsby-pp-site/tutorial-part-one/src/utils/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 339
// module chunks = 231608221292675